import React from 'react';
import { motion } from 'framer-motion';
import { Lightning as LightningIcon, ArrowRight as ArrowRightIcon } from '@phosphor-icons/react';
import { Section, SectionTitle, Lead } from '../Section';
import { signalPanels } from '../../data/proposal';
export function SignalsSection() {
  return <Section id="signals" index="09" label="Signals" className="bg-white/[0.02]" fill data-id="element-279" data-mp="2glztnsftqs0w">
      <div className="grid gap-5 lg:grid-cols-[1fr_0.85fr] lg:items-end lg:gap-14" data-id="element-280" data-mp="2lkt93qeo8t3p">
        <SectionTitle data-id="element-281" data-mp="2liqj36diqzyz">
          Every interaction
          <br data-id="element-282" data-mp="2pl3gn7i43rko" />
          becomes a decision you can make.
        </SectionTitle>
        <Lead data-id="element-283" data-mp="2uclevnsr3e1y">
          Because these are Snaks, the campaign reports back live — not just who clicked, but which
          clinician, which question, which channel. Each signal comes with an action.
        </Lead>
      </div>

      <div className="mt-6 grid min-h-0 flex-1 gap-4 lg:grid-cols-3" data-id="element-284" data-mp="34cm2hlxnkgby">
        {signalPanels.map((panel, panelIndex) => <article key={panel.id} className="flex min-h-0 flex-col rounded-xl border border-white/10 bg-white/[0.03] p-5" data-id="element-285" data-mp="3981f6ajxc66s" data-mpi={panelIndex}>
            <h3 className="font-heading text-xl leading-tight text-white" data-id="element-286" data-mp="27mtxhksiks9">{panel.question}</h3>
            <p className="mt-1 font-body text-[11px] uppercase tracking-[0.14em] text-secondary/70" data-id="element-287" data-mp="3tg0pa9xzk0u4">
              {panel.metric}
            </p>

            <ul className="mt-5 flex-1 space-y-3.5" data-id="element-288" data-mp="3pfgql1xrkp5v">
              {panel.rows.map((row, i) => <li key={row.label} data-id="element-289" data-mp="q03djwk6ekto" data-mpi={i}>
                  <div className="flex items-baseline justify-between gap-3" data-id="element-290" data-mp="kynv8c9dusez">
                    <span className="font-body text-sm text-white/80" data-id="element-291" data-mp="g8fou3f07hvw">{row.label}</span>
                    <span className={`font-heading text-base ${i === 0 ? 'text-primary' : 'text-white/55'}`} data-id="element-292" data-mp="g633rhdy8rem">
                      {row.display}
                    </span>
                  </div>
                  <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-white/10" data-id="element-293" data-mp="13vxd3oz27xu4">
                    <motion.div className={`h-full rounded-full ${i === 0 ? 'bg-primary' : 'bg-secondary/45'}`} initial={{
                width: 0
              }} whileInView={{
                width: `${row.value}%`
              }} viewport={{
                once: true,
                amount: 0.4
              }} transition={{
                duration: 0.8,
                delay: panelIndex * 0.1 + i * 0.08,
                ease: 'easeOut'
              }} data-id="element-294" data-mp="2y7yrd5b6swkh" />
                  </div>
                </li>)}
            </ul>

            <div className="mt-5 flex gap-3 rounded-lg border border-primary/35 bg-primary/[0.08] p-3.5" data-id="element-295" data-mp="25jayooo3z4ww">
              <LightningIcon size={18} weight="fill" className="mt-0.5 shrink-0 text-primary" aria-hidden="true" data-id="element-296" data-mp="2ai4einqvb808" />
              <div data-id="element-297" data-mp="8mkbslmq9ntw">
                <p className="font-body text-[10px] uppercase tracking-[0.18em] text-primary" data-id="element-298" data-mp="1t6pfvsjhv5zo">
                  Action
                </p>
                <p className="mt-1 font-body text-sm leading-relaxed text-white/75" data-id="element-299" data-mp="1o973tta6kang">
                  {panel.action}
                </p>
              </div>
            </div>
          </article>)}
      </div>

      <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-xl border border-white/10 px-5 py-3.5" data-id="element-300" data-mp="1y4h4odouebzn">
        <span className="font-body text-sm text-white/40 line-through" data-id="element-301" data-mp="2bzb882v70efi">
          “Someone clicked the campaign.”
        </span>
        <ArrowRightIcon size={16} className="text-primary" aria-hidden="true" data-id="element-302" data-mp="2lw65kifqc8s7" />
        <span className="font-heading text-base text-white lg:text-lg" data-id="element-303" data-mp="2gwjsqa3tcujx">
          What made them click. What they were interested in. What they thought. What they explored
          next.
        </span>
      </div>
    </Section>;
}